import React from 'react';
import styled from '@emotion/styled';
import Title from './Title';

const Form = styled.form`
	box-sizing: border-box;
	padding: 20px;
	min-width: 300px;
	width: 100%;

	${props => props.theme.form || ''}
`;

const FormInner = styled.div`
	${props => props.theme.formInner || ''}
`;

export default function FormComponent({ children, title, ...props }) {
	return (
		<Form {...props}>
			{title ? <Title>{title}</Title> : null}
			<FormInner>{children}</FormInner>
		</Form>
	);
}
